var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "01) Icons/Filled/people-fill"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Icon \xD0\xA1olor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5002 12.8333C13.0738 12.8333 15.1668 10.7403 15.1668 8.16667C15.1668 5.593 13.0738 3.5 10.5002 3.5C7.9265 3.5 5.8335 5.593 5.8335 8.16667C5.8335 10.7403 7.9265 12.8333 10.5002 12.8333ZM19.8335 15.1667C21.7632 15.1667 23.3335 13.5963 23.3335 11.6667C23.3335 9.737 21.7632 8.16667 19.8335 8.16667C17.9038 8.16667 16.3335 9.737 16.3335 11.6667C16.3335 13.5963 17.9038 15.1667 19.8335 15.1667ZM25.6668 22.1667C25.6668 22.8107 25.1453 23.3333 24.5002 23.3333H18.6668C18.6668 23.9773 18.1453 24.5 17.5002 24.5H3.50016C2.855 24.5 2.3335 23.9773 2.3335 23.3333C2.3335 18.83 5.998 15.1667 10.5002 15.1667C12.7483 15.1667 14.7853 16.0802 16.2635 17.5537C17.2773 16.7697 18.5257 16.3333 19.8335 16.3333C23.05 16.3333 25.6668 18.9502 25.6668 22.1667Z",
    fill: "white",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_651_4269",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 24,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Icon \xD0\xA1olor_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5002 12.8333C13.0738 12.8333 15.1668 10.7403 15.1668 8.16667C15.1668 5.593 13.0738 3.5 10.5002 3.5C7.9265 3.5 5.8335 5.593 5.8335 8.16667C5.8335 10.7403 7.9265 12.8333 10.5002 12.8333ZM19.8335 15.1667C21.7632 15.1667 23.3335 13.5963 23.3335 11.6667C23.3335 9.737 21.7632 8.16667 19.8335 8.16667C17.9038 8.16667 16.3335 9.737 16.3335 11.6667C16.3335 13.5963 17.9038 15.1667 19.8335 15.1667ZM25.6668 22.1667C25.6668 22.8107 25.1453 23.3333 24.5002 23.3333H18.6668C18.6668 23.9773 18.1453 24.5 17.5002 24.5H3.50016C2.855 24.5 2.3335 23.9773 2.3335 23.3333C2.3335 18.83 5.998 15.1667 10.5002 15.1667C12.7483 15.1667 14.7853 16.0802 16.2635 17.5537C17.2773 16.7697 18.5257 16.3333 19.8335 16.3333C23.05 16.3333 25.6668 18.9502 25.6668 22.1667Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_651_4269)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/iconUser.14db503ac7afb034570130244c8f3c61.svg";
export { ForwardRef as ReactComponent };